import pclnExperimentation from '@pcln/experimentation'

export const PKG_ENABLE_FLY_LAP_INFANT_TICKETING = 'PKG_ENABLE_FLY_LAP_INFANT_TICKETING'

type LocationLike = { countryCode?: string | null } | null | undefined

export type FlyLapInfantTicketingImpressionCriteria = {
  tripType: string
  startLocation: LocationLike
  endLocation: LocationLike
}

const hasFlight = (tripType: string) => tripType.includes('FLY')

const isInternationalLocation = (location: LocationLike) =>
  typeof location?.countryCode === 'string' && location.countryCode.toUpperCase() !== 'US'

export const isEligibleForFlyLapInfantTicketingImpression = ({
  tripType,
  startLocation,
  endLocation,
}: FlyLapInfantTicketingImpressionCriteria) =>
  hasFlight(tripType) && (isInternationalLocation(startLocation) || isInternationalLocation(endLocation))

export const maybeFireFlyLapInfantTicketingImpression = (
  criteria: FlyLapInfantTicketingImpressionCriteria,
) => {
  if (!isEligibleForFlyLapInfantTicketingImpression(criteria)) {
    return
  }
  pclnExperimentation.fireImpression(PKG_ENABLE_FLY_LAP_INFANT_TICKETING)
}
